import { Blackjack, SubtractiveGenerator } from 'game-logic';
import { v4 as uuidv4 } from 'uuid';
import { assertNever } from 'src/games/common/helper';
import { GameServices } from '../../../services/game-services';
import { BlackjackAssetType } from '../../../model/blackjack-types';

export class ChipViewModel {
  public get chipAsset() {
    return this.gameServices.assetCatalogueService.getAsset(this.assetType());
  }

  public readonly chipId: string;
  public readonly jitterOffset: { x: number; y: number; angle: number };

  constructor(
    private gameServices: GameServices,
    private chipValue: Blackjack.ChipDenomination,
    seed: number,
  ) {
    this.chipId = uuidv4();
    this.jitterOffset = generateChipOffset(seed);
  }

  private assetType(): BlackjackAssetType {
    switch (this.chipValue) {
      case Blackjack.ChipDenomination.Chip10:
        return BlackjackAssetType.Chip10;
      case Blackjack.ChipDenomination.Chip50:
        return BlackjackAssetType.Chip50;
      case Blackjack.ChipDenomination.Chip100:
        return BlackjackAssetType.Chip100;
      case Blackjack.ChipDenomination.Chip500:
        return BlackjackAssetType.Chip500;
      case Blackjack.ChipDenomination.Chip1k:
        return BlackjackAssetType.Chip1k;
      case Blackjack.ChipDenomination.Chip5k:
        return BlackjackAssetType.Chip5k;
      case Blackjack.ChipDenomination.Chip10k:
        return BlackjackAssetType.Chip10k;
      case Blackjack.ChipDenomination.Chip50k:
        return BlackjackAssetType.Chip50k;
      case Blackjack.ChipDenomination.Chip100k:
        return BlackjackAssetType.Chip100k;
      default:
        assertNever(this.chipValue, 'Invalid chip denomination');
    }
  }
}

function generateChipOffset(seed: number): { x: number; y: number; angle: number } {
  const rng = new SubtractiveGenerator(seed);

  return { x: rng.nextFloat() * 2 - 1, y: rng.nextFloat() * 2 - 1, angle: rng.nextFloat() * 2 - 1 };
}
